__turbopack_context__.v({
  "boatActions": "jumbotron-module-scss-module__t5t6wW__boatActions",
  "boatFav": "jumbotron-module-scss-module__t5t6wW__boatFav",
  "boatReport": "jumbotron-module-scss-module__t5t6wW__boatReport",
  "boatSaves": "jumbotron-module-scss-module__t5t6wW__boatSaves",
  "boatStatistics": "jumbotron-module-scss-module__t5t6wW__boatStatistics",
  "boatTitle": "jumbotron-module-scss-module__t5t6wW__boatTitle",
  "boatViews": "jumbotron-module-scss-module__t5t6wW__boatViews",
  "breadcrumbContainer": "jumbotron-module-scss-module__t5t6wW__breadcrumbContainer",
  "compareAction": "jumbotron-module-scss-module__t5t6wW__compareAction",
  "compareMessage": "jumbotron-module-scss-module__t5t6wW__compareMessage",
  "container": "jumbotron-module-scss-module__t5t6wW__container",
  "containerContent": "jumbotron-module-scss-module__t5t6wW__containerContent",
  "containerSticky": "jumbotron-module-scss-module__t5t6wW__containerSticky",
  "containerStickyHeader": "jumbotron-module-scss-module__t5t6wW__containerStickyHeader",
  "divider": "jumbotron-module-scss-module__t5t6wW__divider",
  "saveAction": "jumbotron-module-scss-module__t5t6wW__saveAction",
  "shareAction": "jumbotron-module-scss-module__t5t6wW__shareAction",
});
